import { Card, CardHeader, Grid } from "@mui/material";
import React from "react";
import ChatboardCorrespondence from "./ChatBoardCorrespondence";



const ChatBoard = ({formData,assignerToChatboard}) => {
    console.log(formData);
  return <div>
    <ChatboardCorrespondence formData={formData} assignerToChatboard={assignerToChatboard} />
  </div>
}

export default ChatBoard;